import { Box, Stack } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { customStyles } from '../../../styles'
import { helpOptions } from '../../../utils/help_options'
import { MainContainer } from '../../containers'
import { MainButton, RegularText, SmallText } from '../../helpers'
import { ModalHeader } from '../../modals'

export const Questions = () => {
  const navigate = useNavigate()
  const navigateTo = () => 
  navigate(-1)
  return (
    <MainContainer>

    <Stack spacing={2} p={2}>
      <ModalHeader text="Preguntas frecuentes" color={customStyles.colors.main} backward action={navigateTo}/>
      {
        helpOptions.map(({ label, list }, idx) => (
          <Box>
            <RegularText text={label}/>
            { list.map((item, index) => (
              <SmallText text={`${idx===1 ? '* ': ''}  ${item}.`} color={customStyles.colors.textColor} sx={{paddingLeft: 1}}/>
            )) }
          </Box>
        ))
      }
    </Stack>
    <MainButton text="regresar" variant="contained"onClick={navigateTo} sx={{ float: 'right' }}/>
    </MainContainer>
  )
}
